import React from 'react';
import { PulseLoader } from 'react-spinners';

const AuthLoader = () => <PulseLoader color={'#fff'} size={10} css="margin-left: 1rem" />;

export default AuthLoader;
